import React from 'react';

interface Transaction {
    from: string;
    to: string;
    amount: number;
}

interface TransactionListProps {
    transactions: Transaction[];
}

export const TransactionList: React.FC<TransactionListProps> = ({ transactions }) => {
    return (
        <div className="transactions-section">
            <h3 className="section-title">💸 정산 내역</h3>
            <div className="transactions-list">
                {transactions.map((transaction, index) => (
                    <div key={index} className="transaction-item">
                        <div className="transaction-from">
                            <div className="person-avatar">👤</div>
                            <div className="person-name">{transaction.from}</div>
                        </div>

                        <div className="transaction-arrow">
                            <div className="arrow-line"></div>
                            <div className="arrow-text">
                                {transaction.amount.toLocaleString('ko-KR')}원
                            </div>
                            <div className="arrow-icon">→</div>
                        </div>

                        <div className="transaction-to">
                            <div className="person-avatar">👤</div>
                            <div className="person-name">{transaction.to}</div>
                        </div>
                    </div>
                ))}
            </div>

            {transactions.length === 0 && (
                <div className="empty-transactions">
                    <div className="empty-icon">✨</div>
                    <div className="empty-text">정산이 완료되었어요!</div>
                </div>
            )}
        </div>
    );
};
